import styles from './CompartmentTile.module.scss'

/**
 * CompartmentTile — DataItem clone with interactive states.
 *
 * Structural clone of shared/ui/DataItem. Level 0 — no hooks, no context reads.
 * Typography scale inherited via --bim-data-label-size / --bim-data-value-size
 * from the tilesRow container (set in CompartmentsList.module.scss).
 *
 * @param {string}   props.label        — short display name (2-line max, truncated)
 * @param {string}  [props.title]       — full name as native browser tooltip when label truncated
 * @param {string}   props.value        — primary value (area m² or variant "X / Y")
 * @param {boolean}  props.isSelected
 * @param {boolean}  props.isHovered
 * @param {boolean} [props.isDisabled]  — ARRANGE only: no variants to cycle
 * @param {Function}[props.onSelect]    — called on click / Enter / Space
 * @param {Function}[props.onHover]     — called on mouseenter
 * @param {Function}[props.onHoverLeave]— called on mouseleave
 */
export function CompartmentTile({
  label,
  title,
  value,
  isSelected = false,
  isHovered  = false,
  isDisabled = false,
  onSelect,
  onHover,
  onHoverLeave,
}) {
  const className = [
    styles.root,
    isHovered  && styles.hovered,
    isSelected && styles.selected,
    isDisabled && styles.disabled,
  ].filter(Boolean).join(' ')

  function handleKeyDown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onSelect?.()
    }
  }

  return (
    <div
      className={className}
      role="button"
      tabIndex={isDisabled ? -1 : 0}
      aria-pressed={isSelected || undefined}
      aria-disabled={isDisabled || undefined}
      title={title}
      onClick={onSelect}
      onMouseEnter={onHover}
      onMouseLeave={onHoverLeave}
      onKeyDown={handleKeyDown}
    >
      <span className={styles.labelRow}>
        <span className={styles.label}>{label}</span>
      </span>
      <span className={styles.value}>{value}</span>
    </div>
  )
}
